import { VIEWER_SET_IS_CORONAL_VIEW_LOADED } from '../actions';

export default function setIsCoronalViewLoaded(isLoaded) {
  return {
    type: VIEWER_SET_IS_CORONAL_VIEW_LOADED,
    isLoaded,
  };
}
